import React from 'react'
import * as S from './styles'

const PixSuccessSection = ({ cancellationData }) => {
  const refundStatus = cancellationData?.cancellationRequest?.refundStatus

  const textMapper = {
    done: 'O reembolso foi realizado com sucesso',
    pending: 'O reembolso será procesado com os dados inseridos',
    processing: 'O reembolso será procesado com os dados inseridos'
  }
  const text = textMapper[refundStatus] || textMapper['pending']

  return (
    <S.PixSuccessContainer>
      <S.InfoIconStyled />
      {text}
    </S.PixSuccessContainer>
  )
}

export default PixSuccessSection
